"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodNotAllowedError = void 0;
const BaseError_1 = require("./BaseError");
class MethodNotAllowedError extends BaseError_1.BaseError {
    constructor(description = "Method not allowed") {
        super("MethodNotAllowedError", 405, description, true);
    }
}
exports.MethodNotAllowedError = MethodNotAllowedError;
